import styled, { keyframes } from 'styled-components';

import ProfileInfo from '../ProfileInfo';

export const StyledHeader = styled.header`
  width: 100%;
  height: 64px;
  background: #fff;
  text-align: center;
  padding: 20px 24px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex-shrink: 0;
  z-index: 9;
  @media (min-width: 480px) {
    height: 78px;
    padding: 18px 26px 20px 25px;
    box-shadow: 0 8px 20px 0 rgba(231, 238, 255, 0.5);
  }
`;

const animationIn = keyframes`
  from {
    transform: scale(.9);
    opacity: .5;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

export const StyledHeaderAction = styled.div<{
  direction?: 'right' | 'left';
}>`
  position: absolute;
  left: ${({ direction }) => (direction === 'left' ? '24px' : '')};
  right: ${({ direction }) => (direction === 'right' ? '24px' : '')};
  top: 20px;
  bottom: 20px;
  height: 24px;
  margin: auto 0;

  & > * {
    display: none;
  }
  & > *:last-child {
    display: block;
    transform: rotate(0deg);
    animation: ${animationIn} 0.2s ease-in;
  }

  @media (min-width: 740px) {
    display: none;
  }
`;

export const StyledMenuButton = styled.button`
  background: transparent;
  border: none;
  color: #3564fd;
  font-size: 24px;
  padding: 0;
`;

export const StyledLogoTipo = styled.img`
  @media (min-width: 740px) {
    display: none;
  }
`;

export const MenuProfileInfo = styled(ProfileInfo)`
  @media (max-width: 740px) {
    display: none;
  }
`;
